export const ALARM_BUTTON_ICONS = [
  "pistol",
  "bomb",
  "fire",
  "alert",
  "medical-bag",
  "ambulance",
  "run-fast",
  "shield",
  "account-alert",
  "car",
  "home-alert",
  "bell",
  "chat-alert",
  "lock",
  "phone",
  "magnify",
  "weather-lightning",
  "water",
  "gas-cylinder",
  "hazard-lights",
];
